/* ==========================================================================
   assets/mega-desktop-drawer.js
   Vanilla JS, no dependencies. Powers every ".dn-mega-drawer" instance on
   the page (the block is limited to 1, but this stays generic on purpose).
   ========================================================================== */
(function () {
  "use strict";

  var instances = Array.prototype.slice.call(document.querySelectorAll(".dn-mega-drawer"));
  if (!instances.length) return;

  instances.forEach(initDrawer);

  function initDrawer(root) {
    var header     = root.closest("header") || root.closest("store-header") || root.parentElement;
    var toggleBtn  = root.querySelector(".dn-hamburger");
    var drawer     = root.querySelector("[data-drawer]");
    var level2Wrap = root.querySelector(".dn-drawer__level2");
    var promoWrap  = root.querySelector(".dn-drawer__promo");

    if (!toggleBtn || !drawer || !header) return;

    var triggers   = Array.prototype.slice.call(drawer.querySelectorAll(".dn-level1__trigger"));
    var panels     = Array.prototype.slice.call(drawer.querySelectorAll(".dn-panel"));
    var accordions = Array.prototype.slice.call(drawer.querySelectorAll("[data-accordion]"));

    var OPEN_GRACE_PERIOD = 3000;
    var graceTimer = null;
    var inGracePeriod = false;
    var pointerIsOutside = false;

    function endGracePeriod() {
      inGracePeriod = false;
      if (graceTimer) {
        clearTimeout(graceTimer);
        graceTimer = null;
      }
    }

    function startGracePeriod() {
      inGracePeriod = true;
      pointerIsOutside = false;
      if (graceTimer) clearTimeout(graceTimer);
      graceTimer = setTimeout(function () {
        inGracePeriod = false;
        graceTimer = null;
        /* grace period elapsed — if the pointer is (still) outside at
           this moment, close now rather than waiting for another
           mouseover event that may never come if the pointer sat still */
        if (pointerIsOutside) closeDrawer();
      }, OPEN_GRACE_PERIOD);
    }

    /* ---------------- open / close the whole drawer ---------------- */

    function openDrawer() {
      drawer.hidden = false;
      toggleBtn.setAttribute("aria-expanded", "true");
      header.classList.add("is-menu-open");
      document.addEventListener("keydown", onKeydown);
      /* brief grace window so the trip from the button down into the
         drawer doesn't get read as "left the menu" and close it early */
      startGracePeriod();
    }

    function closeDrawer() {
      endGracePeriod();
      drawer.hidden = true;
      toggleBtn.setAttribute("aria-expanded", "false");
      header.classList.remove("is-menu-open");
      document.removeEventListener("keydown", onKeydown);
      resetActivePanel();
    }

    function onKeydown(e) {
      if (e.key === "Escape") {
        closeDrawer();
        toggleBtn.focus();
      }
    }

    /* Click-only toggle on the hamburger: click opens, click again closes.
       No hover-to-open — this must not conflict with hover interactions
       elsewhere in the header. */
    toggleBtn.addEventListener("click", function () {
      var isOpen = toggleBtn.getAttribute("aria-expanded") === "true";
      isOpen ? closeDrawer() : openDrawer();
    });

    /* Hovering the sibling <desktop-navigation> (its own separate mega
       menus) always closes this drawer right away — that's an explicit
       "I want the other menu" signal, never held back by the
       open-grace-period. Any other outside hover closes immediately too,
       except during the brief grace window right after opening (see
       startGracePeriod). Uses a bubbling "mouseover" in the capture
       phase so nesting depth and other scripts' stopPropagation() calls
       don't matter. */
    var siblingNav = header.querySelector("desktop-navigation");

    document.addEventListener("mouseover", function (e) {
      if (drawer.hidden) return;
      var target = e.target;

      if (drawer.contains(target)) {
        pointerIsOutside = false;
        endGracePeriod(); /* confirmed arrival in the drawer itself */
        return;
      }

      if (toggleBtn.contains(target)) {
        /* still on the button (or its icon swapped under the cursor
           right after click) — safe, but doesn't count as "arrived", so
           it must not end the grace period early */
        pointerIsOutside = false;
        return;
      }

      if (siblingNav && siblingNav.contains(target)) {
        pointerIsOutside = true;
        closeDrawer();
        return;
      }

      pointerIsOutside = true;
      if (inGracePeriod) return;
      closeDrawer();
    }, true);

    /* ---------------- level 1 -> level 2 (hover-driven) ---------------- */

    function showPanel(name) {
      panels.forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== name; });
      triggers.forEach(function (t) {
        var active = t.getAttribute("data-panel") === name;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-expanded", active ? "true" : "false");
      });
      if (level2Wrap) level2Wrap.hidden = false;
      if (promoWrap) promoWrap.classList.add("is-single");
    }

    function resetActivePanel() {
      triggers.forEach(function (t) {
        t.classList.remove("is-active");
        t.setAttribute("aria-expanded", "false");
      });
      if (level2Wrap) level2Wrap.hidden = true;
      if (promoWrap) promoWrap.classList.remove("is-single");
    }

    triggers.forEach(function (trigger) {
      var name = trigger.getAttribute("data-panel");
      trigger.addEventListener("mouseenter", function () { showPanel(name); });
      trigger.addEventListener("focus", function () { showPanel(name); });
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        showPanel(name);
      });
    });

    var inner = drawer.querySelector(".dn-drawer__inner");
    if (inner) {
      inner.addEventListener("mouseleave", resetActivePanel);
    }

    Array.prototype.slice
      .call(drawer.querySelectorAll(".dn-level1__link:not(.dn-level1__trigger)"))
      .forEach(function (link) {
        link.addEventListener("mouseenter", resetActivePanel);
      });

    /* ---------------- accordions (any level-2 item with children) ---------------- */

    accordions.forEach(function (acc) {
      var trigger = acc.querySelector(".dn-accordion__trigger");
      var panel   = acc.querySelector(".dn-accordion__panel");

      trigger.addEventListener("click", function () {
        var isOpen = trigger.getAttribute("aria-expanded") === "true";

        accordions.forEach(function (other) {
          if (other === acc) return;
          other.querySelector(".dn-accordion__trigger").setAttribute("aria-expanded", "false");
          other.querySelector(".dn-accordion__panel").hidden = true;
        });

        trigger.setAttribute("aria-expanded", String(!isOpen));
        panel.hidden = isOpen;
      });
    });

    resetActivePanel();
  }
})();
